import { Button } from "@design-system/Button/Button";
import { Loader } from "@design-system/Loader/Loader";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { DownloadIcon } from "@icons";
import { useForm1099NecTrack1099Download } from "./useForm1099NecTrack1099Download";

interface Form1099NecExportButtonProps {
    taxYear: number;
    entityId: number | undefined;
    disabled: boolean;
}

export const Form1099NecExportButton = ({
    taxYear,
    entityId,
    disabled,
}: Form1099NecExportButtonProps) => {
    const { download, isDownloading } = useForm1099NecTrack1099Download({
        taxYear,
        entityId,
    });

    return (
        <Tooltip content="Export Track1099 CSV">
            <Button
                type="button"
                variant="primary"
                size="md"
                iconOnly
                aria-label="Export Track1099 CSV"
                disabled={disabled || isDownloading}
                onClick={async () => {
                    await download();
                }}
            >
                {isDownloading ? <Loader inline /> : <DownloadIcon />}
            </Button>
        </Tooltip>
    );
};
